import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'skeleton-map',
  templateUrl: './skeleton-map.component.html',
  styleUrls: ['./skeleton-map.component.scss']
})
export class SkeletonMapComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
